module.exports = __webpack_public_path__ + "img/mapa.ee1434db.svg";